// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xoxC","rootMobile":"styles_rootMobile__34gN7"};